import React from 'react';
import { Box, Stack } from '@mui/material';

import Tooltip from '../../Tooltip';
import EllipsedTypography from '../../Tooltip/EllipsedTypography';

import { hasContent } from '../utils';

interface Props {
  label: React.ReactNode;
  tooltipContent?: React.ReactNode;
  endContent?: React.ReactNode;
  title?: string;
}

export const ChipLabel = ({
  label,
  tooltipContent,
  endContent,
  title,
}: Props) => {
  const hasLabel = hasContent(label);

  if (!hasLabel) return null;

  return (
    <Tooltip title={tooltipContent}>
      <Stack direction='row' alignItems='center'>
        <EllipsedTypography variant='inherit' disableTooltip={!!tooltipContent}>
          {title && (
            <Box className='MuiChip-title' data-test-id='chip-title'>
              {title}:
            </Box>
          )}
          <span data-test-id='chip-label'>{label}</span>
        </EllipsedTypography>
        {endContent}
      </Stack>
    </Tooltip>
  );
};
